import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Popover,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import {
  discussWithAgent,
  getApiCall,
  Moxoseparationinlisting,
  offerWithdrawVendor,
  replyToVendorStatus,
  stageTwoSwitching,
  dateformatBasedOnUserType,
} from 'api/apiService';
import UserImg from 'assets/dummy/profile.svg';
import { ReactComponent as Call } from 'assets/icons/Calls.svg';
import { ReactComponent as Message } from 'assets/icons/chats.svg';
import vendorStatus from 'assets/icons/vendorStatus.png';
import { ReactComponent as Propertymenu } from 'assets/svg/propertymenu.svg';
import BadgeButton from 'component/BuyerRegistration/components/BadgeButton';
import ManageOffer from 'component/BuyerRegistration/ManageOffer';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import CardHeaderContainer from 'component/CardHeaderContainer/CardHeaderContainer';
import ContactPopOver from 'component/ContactTab/ContactPopOver';
import {
  API_URL,
  CONTRACT_FILE_UPLOAD,
  GET_BINDERID,
  VENDOR_REQUEST_SIGN_TEMPLATE,
} from 'constant/app.config';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import ManagePrivateOffer from 'modules/private/AgentDashboard/ManagePrivateOffer';
import { AGENT_MANAGE_PRIVATE_OFFER } from 'constant/app.config';
import {
  displayFlex,
  displayFlexColumn,
  fontsize14,
  fontsize16,
  fontsize32,
  menuitemfont,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import {
  counterOffer,
  counterOfferButton,
  vendorAvatar,
  vendorCard,
  vendorRight,
  vendorTop,
} from './VendorStatusContainer.style';
import CommenceStageTwo from 'component/VendorStatusContainer/CommenceStageTwo';
import ContactDrawer from './ContactDrawer';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ForwardCounterOfferPopup from './ForwardCounterOfferPopup';
import { useLocation } from 'react-router-dom';
import Loading from 'assets/images/loading.png';
import VendorActionDrawer from './VendorActionDrawer';
import PrivateOfferConfirmationPopup from './PrivateOfferConfirmationPopup';
import DepositManagerPopup from './DepositManager/DepositManagerPopup';
import Privateofferdetailslink from 'component/BuyersMarketplace/Privateofferdetailslinkpopup';
import ShareOfferWithMarketPlace from 'component/BuyerRegistration/ShareOfferWithMarketPlace';
import Stage2Commence from 'component/BuyerOfferCard/Stage2Commence';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { SignContract } from 'component/BuyerRegistration/components/Actionbtn';
import PrepareContractSignDialog from 'component/BuyerRegistration/components/PrepareContractSignDialog';
import FinalContractUploadDialog from 'component/BuyerRegistration/components/FinalContractUploadDialog';
import { postApiCall } from 'api/apiService';
import CommenceESignDialog from 'component/BuyersMarketplace/CommenceESignDialog';
import ViewCommenceEsignPdf from 'component/BuyersMarketplace/ViewCommenceEsignPdf';
import { ReactComponent as Filemanagericon } from 'assets/svg/Paper.svg';
import CommonPdfViewer from 'component/Common/CommonPdfViewer';

export const Calldownarrow = () => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.44887 7.77981C3.40779 7.73979 3.23213 7.58867 3.08763 7.4479C2.17883 6.6226 0.691333 4.46966 0.237292 3.34281C0.164333 3.17168 0.00991667 2.73902 0 2.50785C0 2.28635 0.051 2.07519 0.154417 1.8737C0.298917 1.62252 0.526292 1.42103 0.79475 1.31062C0.981042 1.23955 1.5385 1.12914 1.54842 1.12914C2.15829 1.01873 3.14925 0.958008 4.24433 0.958008C5.28771 0.958008 6.23829 1.01873 6.85737 1.10913C6.86729 1.11948 7.56004 1.22989 7.79733 1.35064C8.23083 1.57215 8.5 2.00481 8.5 2.46783V2.50785C8.48938 2.8094 8.22021 3.44356 8.21029 3.44356C7.75554 4.50968 6.341 6.61294 5.40104 7.45825C5.40104 7.45825 5.1595 7.69632 5.00863 7.79983C4.79187 7.9613 4.52342 8.04134 4.25496 8.04134C3.95533 8.04134 3.67625 7.95095 3.44887 7.77981Z"
        fill="#666666"
      />
    </svg>
  );
};
const RequestIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4062 19.2H18.3281C18.5437 18.475 18.6875 17.75 18.6875 17.025C18.6875 13.4 15.8125 10.5 12.2188 10.5C8.625 10.5 5.75 13.4 5.75 17.025C5.75 17.75 5.89375 18.475 6.10938 19.2H5.03125C4.6 19.2 4.3125 19.49 4.3125 19.925C4.3125 20.36 4.6 20.65 5.03125 20.65H13.5125H17.1781H19.3344C19.7656 20.65 20.0531 20.36 20.0531 19.925C20.0531 19.49 19.8375 19.2 19.4062 19.2ZM7.1875 17.025C7.1875 14.1975 9.41563 11.95 12.2188 11.95C15.0219 11.95 17.25 14.1975 17.25 17.025C17.25 17.75 17.1062 18.5475 16.7469 19.2H14.6625C14.6625 19.1275 14.6625 19.055 14.6625 18.9825C14.6625 17.895 13.8 17.025 12.7219 17.025H11.5C11.2125 17.025 10.9969 16.8075 10.9969 16.5175C10.9969 16.2275 11.2125 16.01 11.5 16.01H13.8719C14.3031 16.01 14.5906 15.72 14.5906 15.285C14.5906 14.85 14.3031 14.56 13.8719 14.56H12.9375V14.125C12.9375 13.69 12.65 13.4 12.2188 13.4C11.7875 13.4 11.5 13.69 11.5 14.125V14.6325C10.4938 14.705 9.70312 15.5025 9.70312 16.5175C9.70312 17.605 10.5656 18.475 11.6438 18.475H12.8656C13.1531 18.475 13.3688 18.6925 13.3688 18.9825C13.3688 19.055 13.3687 19.1275 13.2969 19.2H7.7625C7.33125 18.5475 7.1875 17.75 7.1875 17.025Z"
        fill="#112347"
      />
      <path
        d="M2.15625 11.9501C2.73125 11.9501 3.30625 11.7326 3.66562 11.2976C4.025 10.9351 4.24062 10.5001 4.3125 9.9926L5.75 10.3551C5.89375 10.4276 6.10938 10.4276 6.25312 10.4276C6.68437 10.4276 7.04375 10.2826 7.40313 10.0651L12.2188 7.0201L15.5969 9.8476C15.9563 10.1376 16.4594 10.3551 16.9625 10.3551C17.1063 10.3551 17.3219 10.3551 17.4656 10.2826L19.6219 9.7026C19.8375 9.6301 20.0531 9.4126 20.125 9.1951C20.1969 8.9776 20.125 8.6876 19.9094 8.4701L13.8719 2.3801C13.4406 2.0176 12.9375 1.8001 12.3625 1.8001H4.16875C3.88125 0.930098 3.09063 0.350098 2.15625 0.350098C0.934375 0.350098 0 1.2926 0 2.5251V9.7751C0 11.0076 0.934375 11.9501 2.15625 11.9501ZM12.8656 3.4676L18.0406 8.6876L17.1062 8.9051C16.8906 8.9776 16.675 8.9051 16.4594 8.7601L12.7219 5.6426C12.65 5.5701 12.65 5.5701 12.5781 5.5701C12.5781 5.5701 12.5781 5.5701 12.5062 5.5701C12.4344 5.4251 12.2906 5.4251 12.2188 5.4251H7.1875C6.75625 5.4251 6.46875 5.7151 6.46875 6.1501C6.46875 6.5851 6.75625 6.8751 7.1875 6.8751H9.70312L6.6125 8.8326C6.46875 8.9051 6.25312 8.9776 6.0375 8.9051L4.3125 8.4701V3.2501H12.3625C12.5063 3.2501 12.7219 3.3226 12.8656 3.4676ZM1.4375 2.5251C1.4375 2.0901 1.725 1.8001 2.15625 1.8001C2.5875 1.8001 2.875 2.0901 2.875 2.5251V9.0501V9.7751C2.875 9.9926 2.80312 10.1376 2.65937 10.2826C2.51562 10.4276 2.37188 10.5001 2.15625 10.5001C1.725 10.5001 1.4375 10.2101 1.4375 9.7751V2.5251Z"
        fill="#112347"
      />
    </svg>
  );
};
export const ActionDown = () => {
  return (
    <svg
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.464561 0.755281C0.622835 0.597365 0.870509 0.583009 1.04504 0.712213L1.09504 0.755281L4.66732 4.31961L8.23959 0.755281C8.39787 0.597365 8.64554 0.583009 8.82007 0.712213L8.87007 0.755281C9.02835 0.913197 9.04274 1.16031 8.91324 1.33444L8.87007 1.38433L4.98256 5.26305C4.82428 5.42096 4.57661 5.43532 4.40208 5.30611L4.35208 5.26305L0.464561 1.38433C0.290459 1.21062 0.290459 0.928989 0.464561 0.755281Z"
        fill="black"
      />
    </svg>
  );
};

export const PrivateOffer = () => {
  return (
    <svg
      version="1.1"
      id="Icons"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
      width="28"
      height="28"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="none"
          stroke="#000000"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M29,12.6V10c0-0.6-0.4-1-1-1h-6.3c-0.3,0.6-1,1-1.7,1s-1.4-0.4-1.7-1H4c-0.6,0-1,0.4-1,1v2.6c1.2,0.7,2,2,2,3.4
            s-0.8,2.8-2,3.4V22c0,0.6,0.4,1,1,1h14.3c0.3-0.6,1-1,1.7-1s1.4,0.4,1.7,1H28c0.6,0,1-0.4,1-1v-2.6c-1.2-0.7-2-2-2-3.4
            S27.8,13.2,29,12.6z"
        />
        <line
          x1="20"
          y1="13"
          x2="20"
          y2="14"
          stroke="#000000"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="20"
          y1="19"
          x2="20"
          y2="18"
          stroke="#000000"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="11"
          y1="12"
          x2="11"
          y2="13"
          stroke="#000000"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="11"
          y1="19"
          x2="11"
          y2="20"
          stroke="#000000"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12,13h-1.5C9.7,13,9,13.7,9,14.5v0c0,0.8,0.7,1.5,1.5,1.5h1c0.8,0,1.5,0.7,1.5,1.5v0c0,0.8-0.7,1.5-1.5,1.5H10"
          fill="none"
          stroke="#000000"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  );
};

function VendorStatusContainer(props) {
  const {
    profileDetails,
    Glass,
    onShowChat,
    getListInfo,
    activityfun,
    offerdata,
    buyerRegisterTableData,
    vendorDatas,
    acceptanceCertificate,
    setAcceptanceCertificate,
    openFromBannerCommenceStageTwo,
    stage2AcceptanceCertificate,
    setStage2AcceptanceCertificate,
    setVendorGeneratePdf,
    openCommenceStageTwo,
    setOpenCommenceStageTwo,
  } = props;
  const [openDrawer, setDrawerOpen] = useState(false);
  const history = useHistory();
  const [forwardcountertobuyer, setForwardCountertobuyer] = useState(false);
  const [shareMarketPlace, setShareMarketPlace] = React.useState(false);
  const [stagetwo, setStagetwo] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const { dashboardCommenceStage2 } = location?.state || {};
  const [signBuyerId, setSignBuyerId] = useState(0);
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const data = props?.profileDetails?.PropertyDetails?.vendorStatus;
  const vendorCounterPrice =
    props?.profileDetails?.PropertyDetails?.vendorStatus?.price;
  const formattedVendorCounterPrice = vendorCounterPrice
    ? vendorCounterPrice.replace(/[$,]/g, '')
    : ' ';
  const lowestAcceptedOffer = props?.profileDetails?.lowestAcceptedOffer;
  const vendorofferUniqueId =
    props?.profileDetails?.PropertyDetails?.vendorStatus?.offerUniqueId;
  const vendorofferStatus =
    props?.profileDetails?.PropertyDetails?.vendorStatus?.status;
  const stage = props?.profileDetails?.PropertyDetails?.stage;
  const offerStatusdata = props?.profileDetails?.PropertyDetails?.offerStatus;
  const isWinner = props?.profileDetails?.PropertyDetails?.isWinner;
  const sharedToMarket =
    props?.profileDetails?.PropertyDetails?.vendorStatus?.isMarket;
  const address =
    props?.profileDetails?.PropertyDetails?.propertyAddress?.streetName;
  const selectedrowbuyername = data?.buyerName + ' ' + data?.buyerLastName;
  const buyerOfferPrice = data?.buyerOfferPrice;
  let acceptLog = data?.status == 'Accepted' ? 1 : 0;
  const moment = require('moment');
  const { setShowMessage, setMessagedata } = useContext(datacontext);

  const formattedDateTime = moment(data?.lastUpdated).format(
    'DD-MM-YYYY HH:mm:ss'
  );

  const statusVendor =
    props?.profileDetails?.PropertyDetails?.offerStatus?.status;
  const stageval = props?.profileDetails?.BuyerRegisterDetails;

  useEffect(() => {
    if (dashboardCommenceStage2) {
      history.replace({
        pathname: location.pathname,
        state: { ...location.state, dashboardCommenceStage2: false },
      });
    }
  }, [dashboardCommenceStage2, location, history]);

  useEffect(() => {
    if (props?.profileDetails?.PropertyDetails?.isApprovedLog != 0) {
      setStagetwo(true);
    } else {
      setStagetwo(false);
    }
  }, [profileDetails]);

  const vendorPrice = props?.profileDetails?.PropertyDetails?.offerStatus;
  const vendorStatuss = data?.status;

  const datamain = props?.profileDetails?.PropertyDetails?.property;
  const name = props?.profileDetails?.PropertyDetails?.propertyOwnerDetails;
  const [selectedOption, setSelectedOption] = useState(1);
  const [selectedOptionCos, setSelectedOptionCos] = useState(1);
  const [selectedVendorIndex, setSelectedVendorIndex] = useState(0);
  const [forwardtobuyerbox, setForwardtobuyerbox] = useState(false);

  const [forwardtovendor, setForwardtovendor] = useState(false);
  const [menuicon, setMenuicon] = useState(false);
  const [loader, setLoader] = useState(false);
  const params = useParams();
  const [manageOffer, setManageOffer] = useState(false);
  const [vendorStatusManageOffer, setVendorStatusManageOffer] = useState(false);
  const [openhistorydialog, setOpenhistorydialog] = useState(false);
  const [openWithdrawVendorLoader, setOpenWithdrawVendorLoader] =
    useState(false);
  const [openWithdrawVendor, setOpenWithdrawVendor] = useState(false);
  const [selectedVendorName, setSelectedVendorName] = useState('');
  const [selectedVendor, setSelectedVendor] = useState({});
  const [actionDrawerOpen, setActionDrawerOpen] = useState(false);
  const { privateofferprice } = location.state ? location.state : '';
  const { propertyIds } = location.state ? location.state : '';
  const [viewPrivateOffer, setViewPrivateOffer] = useState(false);
  const [viewPrivateOfferlinkpopup, setViewPrivateOfferlinkpopup] =
    useState(false);

  useEffect(() => {
    if (dashboardCommenceStage2 || openFromBannerCommenceStageTwo) {
      setOpenCommenceStageTwo(true);
      setstagetwoCommence(false);
      history.push({
        pathname: history.location.pathname,
        state: { dashboardCommenceStage2: false },
      });
    }
  }, [openFromBannerCommenceStageTwo, dashboardCommenceStage2]);

  const [openstagetwoCommence, setstagetwoCommence] = useState(false);
  useEffect(() => {
    if (
      props?.profileDetails?.PropertyDetails?.isFirstOfferAccepted === 1 &&
      props?.profileDetails?.PropertyDetails?.stage !== 'ST2' &&
      props?.profileDetails?.isReminderStage2Log === 1 &&
      userDetail?.primaryUserType === 'Agent' &&
      props?.profileDetails?.PropertyDetails?.timerStatus === 'Start'
    ) {
      if (!openCommenceStageTwo && !dashboardCommenceStage2) {
        setstagetwoCommence(true);
      }
    } else {
      setstagetwoCommence(false);
    }
  }, [props?.profileDetails]);

  useEffect(() => {
    const offerPriceStr =
      props?.profileDetails?.PropertyDetails?.privateOfferDetails
        ?.privateOfferPrice;
    const parsedOfferPrice = offerPriceStr
      ? parseFloat(offerPriceStr.replace(/[^0-9.-]+/g, ''))
      : null;
    if (
      propertyIds ==
      props?.profileDetails?.PropertyDetails?.property?.propertyId
    ) {
      if (privateofferprice != null && privateofferprice !== undefined) {
        if (parsedOfferPrice == privateofferprice) {
          setViewPrivateOffer(true);
        } else {
          setViewPrivateOfferlinkpopup(true);
        }
      }
    }
  }, [
    location.state,
    props?.profileDetails?.PropertyDetails?.privateOfferDetails
      ?.privateOfferPrice,
  ]);

  const withDrawFunc = (offerStatusId, offerUniqueId, status) => {
    setOpenWithdrawVendorLoader(true);
    const input = {
      offerUniqueId: offerUniqueId,
      offerStatus: status,
      offerStatusId: offerStatusId,
    };
    offerWithdrawVendor(input)
      .then((res) => {
        if (res?.status == 1) {
          setOpenWithdrawVendor(false);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          });
          getListInfo('apiupdated', params?.dashboardId);
          setOpenWithdrawVendorLoader(false);
        } else {
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
          setOpenWithdrawVendorLoader(false);
        }
      })
      .catch(() => setOpenWithdrawVendor(false));
  };

  const manageOfferClick = () => {
    setManageOffer(true);
  };
  const vendorStatusManageOfferClick = () => {
    setVendorStatusManageOffer(true);
  };
  const vendorStatusManageClickClose = () => {
    setVendorStatusManageOffer(false);
    handleClosee();
  };

  const manageOfferClickClose = () => {
    setManageOffer(false);
    handleClosee();
  };

  const data1 = localStorage.getItem('cardSt2');

  useEffect(() => {
    const myfunc = async () => {
      setTimeout(async () => {
        if (data1 == 'CommenceStage2') {
          await setForwardtobuyerbox(true);
        }
      }, 2000);
      localStorage.setItem('cardSt2', '');
    };
    myfunc();
  }, []);

  const [openDepositManager, setOpenDepositManager] = useState(false);

  const handleOpendeposit = () => {
    setOpenDepositManager(true);
  };
  const handleClosedeposit = () => {
    setOpenDepositManager(false);
    setOpen(false);
  };

  const headCells = [
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Name',
    },
    {
      id: 'contact',
      numeric: true,
      disablePadding: false,
      label: 'Contact',
    },
    {
      id: 'buyerreadlines',
      numeric: true,
      disablePadding: false,
      label: 'Buyer Readlines',
    },
    {
      id: 'status',
      numeric: true,
      disablePadding: false,
      label: 'Status',
    },
    {
      id: 'offer',
      numeric: true,
      disablePadding: false,
      label: 'Offer',
    },
    {
      id: 'noofoffer',
      numeric: true,
      disablePadding: false,
      label: 'Number of offers',
    },
    {
      id: 'propertyrating',
      numeric: true,
      disablePadding: false,
      label: 'Property Rating',
    },
    {
      id: 'exp',
      numeric: true,
      disablePadding: false,
      label: 'Exp',
    },
    {
      id: 'profile',
      numeric: true,
      disablePadding: false,
      label: 'Profile',
    },
    {
      id: 'profile',
      numeric: true,
      disablePadding: false,
      label: '',
    },
    {
      id: 'action',
      numeric: true,
      disablePadding: false,
      label: 'Action Required',
    },
  ];
  const Alert = ({ color }) => {
    return (
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_668_108590)">
          <path
            d="M14.7465 12.051L9.17197 2.39555C8.86199 1.85866 8.30679 1.53809 7.68678 1.53809C7.06679 1.53809 6.51156 1.85866 6.20158 2.39555L0.627035 12.051C0.31703 12.5879 0.31703 13.229 0.627035 13.7659C0.937041 14.3028 1.49222 14.6234 2.11223 14.6234H13.2613C13.8813 14.6234 14.4365 14.3028 14.7465 13.7659C15.0565 13.229 15.0565 12.5879 14.7465 12.051ZM14.0066 13.3387C13.851 13.6081 13.5724 13.769 13.2613 13.769H2.11223C1.80111 13.769 1.52253 13.6081 1.367 13.3387C1.21147 13.0693 1.21147 12.7477 1.367 12.4782L6.9416 2.8228C7.09713 2.55339 7.37572 2.39256 7.6868 2.39256C7.99786 2.39256 8.27648 2.55339 8.43201 2.8228L14.0066 12.4782C14.1621 12.7477 14.1621 13.0693 14.0066 13.3387Z"
            fill={color}
          />
          <path
            d="M8.11226 5.80273H7.25781V10.075H8.11226V5.80273Z"
            fill={color}
          />
          <path
            d="M7.68684 10.9297C7.37273 10.9297 7.11719 11.1852 7.11719 11.4993C7.11719 11.8134 7.37273 12.069 7.68684 12.069C8.00092 12.069 8.25649 11.8134 8.25649 11.4993C8.25649 11.1852 8.00094 10.9297 7.68684 10.9297Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_668_108590">
            <rect
              width="14.5845"
              height="14.5845"
              fill="white"
              transform="translate(0.394531 0.789062)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const OpenIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 39 38"
        fill="none"
      >
        <path
          d="M37.7863 19.1323C37.7863 9.03333 29.5995 0.846539 19.5006 0.846539C9.40164 0.846539 1.21484 9.03333 1.21484 19.1323C1.21484 29.2312 9.40164 37.418 19.5006 37.418C29.5995 37.418 37.7863 29.2312 37.7863 19.1323Z"
          stroke="#6C2AD2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5006 17.3465C19.9094 17.3465 20.36 17.5559 20.7184 17.9143C21.0768 18.2727 21.2863 18.7234 21.2863 19.1322C21.2863 19.5409 21.0769 19.9908 20.7187 20.3485C20.3605 20.7061 19.9098 20.9152 19.5006 20.9152C19.0914 20.9152 18.6406 20.7061 18.2824 20.3485C17.9242 19.9908 17.7148 19.5409 17.7148 19.1322C17.7148 18.7234 17.9243 18.2727 18.2827 17.9143C18.6411 17.5559 19.0917 17.3465 19.5006 17.3465ZM19.5006 26.4893C19.9094 26.4893 20.36 26.6988 20.7184 27.0572C21.0768 27.4156 21.2863 27.8662 21.2863 28.275C21.2863 28.6837 21.0769 29.1336 20.7187 29.4913C20.3605 29.849 19.9098 30.0581 19.5006 30.0581C19.0914 30.0581 18.6406 29.849 18.2824 29.4913C17.9242 29.1336 17.7148 28.6837 17.7148 28.275C17.7148 27.8662 17.9243 27.4156 18.2827 27.0572C18.6411 26.6988 19.0917 26.4893 19.5006 26.4893ZM19.5006 8.20361C19.9094 8.20361 20.36 8.41305 20.7184 8.77145C21.0768 9.12985 21.2863 9.58051 21.2863 9.98933C21.2863 10.398 21.0769 10.8479 20.7187 11.2056C20.3605 11.5633 19.9098 11.7724 19.5006 11.7724C19.0914 11.7724 18.6406 11.5633 18.2824 11.2056C17.9242 10.8479 17.7148 10.398 17.7148 9.98933C17.7148 9.58051 17.9243 9.12985 18.2827 8.77145C18.6411 8.41305 19.0917 8.20361 19.5006 8.20361Z"
          fill="black"
          stroke="#6C2AD2"
        />
      </svg>
    );
  };
  const CloseIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 39 38"
        fill="none"
      >
        <path
          d="M19.5006 37.4181C29.5995 37.4181 37.7863 29.2313 37.7863 19.1324C37.7863 9.03347 29.5995 0.84668 19.5006 0.84668C9.40164 0.84668 1.21484 9.03347 1.21484 19.1324C1.21484 29.2313 9.40164 37.4181 19.5006 37.4181Z"
          stroke="#6C2AD2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.2859 19.1324C21.2859 19.5412 21.0764 19.9919 20.718 20.3503C20.3596 20.7087 19.909 20.9181 19.5001 20.9181C19.0914 20.9181 18.6415 20.7088 18.2839 20.3505C17.9262 19.9923 17.7171 19.5416 17.7171 19.1324C17.7171 18.7232 17.9262 18.2725 18.2839 17.9142C18.6415 17.556 19.0914 17.3467 19.5001 17.3467C19.909 17.3467 20.3596 17.5561 20.718 17.9145C21.0764 18.2729 21.2859 18.7236 21.2859 19.1324ZM12.143 19.1324C12.143 19.5412 11.9336 19.9919 11.5752 20.3503C11.2168 20.7087 10.7661 20.9181 10.3573 20.9181C9.94859 20.9181 9.49869 20.7088 9.14101 20.3505C8.78333 19.9923 8.57422 19.5416 8.57422 19.1324C8.57422 18.7232 8.78333 18.2725 9.14101 17.9142C9.49869 17.556 9.94859 17.3467 10.3573 17.3467C10.7661 17.3467 11.2168 17.5561 11.5752 17.9145C11.9336 18.2729 12.143 18.7236 12.143 19.1324ZM30.4287 19.1324C30.4287 19.5412 30.2193 19.9919 29.8609 20.3503C29.5025 20.7087 29.0518 20.9181 28.643 20.9181C28.2343 20.9181 27.7844 20.7088 27.4267 20.3505C27.069 19.9923 26.8599 19.5416 26.8599 19.1324C26.8599 18.7232 27.069 18.2725 27.4267 17.9142C27.7844 17.556 28.2343 17.3467 28.643 17.3467C29.0518 17.3467 29.5025 17.5561 29.8609 17.9145C30.2193 18.2729 30.4287 18.7236 30.4287 19.1324Z"
          fill="black"
          stroke="#6C2AD2"
        />
      </svg>
    );
  };
  const Reply = () => {
    return (
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.75 10.4361H9.35C10.6623 10.4356 11.9498 10.774 13.0733 11.4145C14.1968 12.055 15.1135 12.9734 15.7244 14.0703C15.7416 13.8667 15.7501 13.6626 15.75 13.4583C15.75 9.2854 12.1684 5.90278 7.75 5.90278V2.125L-0.25 8.16944L7.75 14.2139V10.4361Z"
          fill="#2F3F5E"
        />
      </svg>
    );
  };
  const Timer = () => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.51496 1.01896C8.34401 1.00635 8.17225 1 8 1V0C8.19685 0 8.39314 0.00726199 8.58852 0.0216722L8.51496 1.01896ZM10.5193 1.46905C10.1985 1.34533 9.86912 1.2454 9.53371 1.17008L9.75282 0.194382C10.1361 0.280463 10.5126 0.394665 10.8792 0.536055L10.5193 1.46905ZM11.889 2.17971C11.7458 2.08402 11.5994 1.99388 11.4503 1.90939L11.9432 1.0393C12.1136 1.13586 12.2809 1.23888 12.4446 1.34824C12.6082 1.4576 12.7674 1.5727 12.9219 1.69322L12.3066 2.48158C12.1715 2.37612 12.0322 2.27541 11.889 2.17971ZM13.7231 3.96934C13.5252 3.68829 13.3068 3.42218 13.0697 3.17321L13.794 2.48368C14.0649 2.76821 14.3145 3.07233 14.5407 3.39353L13.7231 3.96934ZM14.4672 5.32122C14.4012 5.16208 14.3296 5.00583 14.2526 4.85271L15.1458 4.40311C15.2339 4.5781 15.3157 4.75667 15.391 4.93853C15.4664 5.12039 15.5348 5.30453 15.5962 5.49054L14.6467 5.80423C14.5929 5.64147 14.5331 5.48035 14.4672 5.32122ZM14.9979 7.82822C14.9895 7.48455 14.9557 7.14197 14.8969 6.80326L15.8822 6.63231C15.9494 7.01939 15.988 7.41092 15.9976 7.80367L14.9979 7.82822ZM14.8655 9.36563C14.8991 9.1967 14.9264 9.02699 14.9474 8.85687L15.9398 8.97929C15.9159 9.17372 15.8847 9.36766 15.8463 9.56072C15.8079 9.75378 15.7625 9.94489 15.7102 10.1337L14.7464 9.867C14.7922 9.70179 14.8319 9.53457 14.8655 9.36563ZM13.914 11.745C14.0979 11.4546 14.2602 11.151 14.3995 10.8367L15.3137 11.2419C15.1545 11.6011 14.969 11.9481 14.7588 12.28L13.914 11.745ZM12.9497 12.9497C13.0715 12.828 13.1885 12.702 13.3005 12.5722L14.0577 13.2254C13.9297 13.3737 13.796 13.5177 13.6569 13.6569L12.9497 12.9497Z"
          fill="#F93939"
        />
        <path
          d="M8 1C6.84885 1 5.71545 1.2839 4.70022 1.82655C3.68499 2.3692 2.81926 3.15386 2.17971 4.11101C1.54017 5.06816 1.14654 6.16827 1.03371 7.31388C0.920876 8.45949 1.09232 9.61525 1.53285 10.6788C1.97337 11.7423 2.66939 12.6808 3.55925 13.4111C4.44911 14.1414 5.50533 14.6409 6.63437 14.8655C7.76341 15.0901 8.93041 15.0327 10.032 14.6986C11.1336 14.3644 12.1358 13.7637 12.9497 12.9497L13.6569 13.6569C12.7266 14.5871 11.5812 15.2736 10.3223 15.6555C9.06332 16.0374 7.72961 16.1029 6.43928 15.8463C5.14895 15.5896 3.94183 15.0187 2.92486 14.1841C1.90788 13.3495 1.11243 12.2769 0.608966 11.0615C0.105504 9.846 -0.0904279 8.52514 0.0385242 7.21586C0.167476 5.90659 0.617333 4.64933 1.34825 3.55544C2.07916 2.46155 3.06857 1.5648 4.22883 0.94463C5.38909 0.324457 6.68439 0 8 0V1Z"
          fill="#F93939"
        />
        <path
          d="M7.5 3C7.77614 3 8 3.22386 8 3.5V8.70984L11.2481 10.5659C11.4878 10.7029 11.5711 11.0083 11.4341 11.2481C11.2971 11.4878 10.9917 11.5711 10.7519 11.4341L7.25193 9.43412C7.09615 9.3451 7 9.17943 7 9V3.5C7 3.22386 7.22386 3 7.5 3Z"
          fill="#F93939"
        />
      </svg>
    );
  };
  const NeedHelp = () => {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
          stroke="#EEAD06"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 17.7085V17.7189"
          stroke="#EEAD06"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5013 14.0627C12.4821 13.7246 12.5733 13.3893 12.7612 13.1075C12.9491 12.8257 13.2235 12.6126 13.543 12.5002C13.9345 12.3505 14.2859 12.1119 14.5696 11.8033C14.8533 11.4947 15.0614 11.1244 15.1777 10.7217C15.2939 10.3189 15.3151 9.89468 15.2396 9.48236C15.164 9.07004 14.9938 8.68089 14.7423 8.34554C14.4907 8.01019 14.1648 7.7378 13.7901 7.54982C13.4155 7.36183 13.0023 7.26338 12.5831 7.26222C12.1639 7.26105 11.7502 7.35721 11.3745 7.54312C10.9988 7.72902 10.6713 7.9996 10.418 8.33355"
          stroke="#EEAD06"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const ForwardOff = () => {
    return (
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.25 10.4361H8.65C7.33768 10.4356 6.05019 10.774 4.9267 11.4145C3.80322 12.055 2.88648 12.9734 2.2756 14.0703C2.25843 13.8667 2.24989 13.6626 2.25 13.4583C2.25 9.2854 5.8316 5.90278 10.25 5.90278V2.125L18.25 8.16944L10.25 14.2139V10.4361Z"
          fill="#2F3F5E"
        />
      </svg>
    );
  };
  const Offer = () => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.33233 7.80887L5.33168 7.82033C5.28733 8.5971 5.72244 9.32479 6.44047 9.67366L6.44784 9.67726C6.70098 9.79835 6.90847 9.99798 7.03938 10.2462L7.04232 10.2516C7.40412 10.9405 8.15242 11.3581 8.95015 11.3162L8.96226 11.3156C9.25156 11.2994 9.53874 11.374 9.78354 11.5291C10.459 11.9516 11.3165 11.9516 11.992 11.5291C12.2368 11.374 12.5239 11.2994 12.8133 11.3156L12.8254 11.3162C13.6218 11.3584 14.3711 10.9405 14.7337 10.2505L14.7355 10.2467C14.8669 9.99782 15.0749 9.79786 15.3288 9.67661L15.3347 9.67366C16.0527 9.32463 16.488 8.5971 16.4435 7.82016L16.4428 7.80936C16.4281 7.53576 16.504 7.26495 16.6592 7.03897C17.1057 6.3877 17.1057 5.52894 16.6593 4.87751C16.5044 4.65169 16.4281 4.38104 16.4428 4.10744L16.4435 4.09599C16.488 3.31905 16.0527 2.59152 15.3341 2.24233L15.3275 2.23905C15.0749 2.11829 14.8679 1.91964 14.7368 1.67206L14.733 1.66469C14.3711 0.975788 13.6218 0.558355 12.8254 0.600082L12.8131 0.600736C12.5239 0.616936 12.2368 0.542319 11.9921 0.387192H11.9918C11.3163 -0.0353141 10.4589 -0.0353141 9.78338 0.387192C9.53858 0.542155 9.2514 0.616773 8.96209 0.600573L8.94998 0.599918C8.15341 0.5577 7.40428 0.975625 7.04249 1.66437L7.0397 1.66944C6.90863 1.91816 6.70098 2.11796 6.44751 2.23922L6.44064 2.24249C5.7226 2.59136 5.28733 3.31905 5.33184 4.09599L5.3325 4.10679C5.34722 4.38038 5.2713 4.6512 5.11617 4.87702C4.66961 5.52845 4.66961 6.38737 5.11617 7.03864C5.27113 7.26446 5.34722 7.53527 5.33233 7.80887ZM5.66779 5.25763C5.90718 4.90909 6.02451 4.49117 6.0016 4.06899L6.00095 4.05753C5.97738 3.54274 6.26636 3.06459 6.73289 2.84581L6.73862 2.84303C7.12136 2.65976 7.43472 2.35802 7.63239 1.98264L7.63566 1.97642C7.87604 1.51857 8.37955 1.24104 8.91431 1.26951L8.92609 1.27C9.354 1.29406 9.77863 1.18377 10.1406 0.954352C10.5976 0.668481 11.1776 0.668481 11.6346 0.954352C11.9965 1.18344 12.4212 1.2939 12.8489 1.27017L12.8607 1.26951C13.3981 1.24137 13.8991 1.51857 14.1389 1.97511L14.1433 1.98345C14.341 2.35834 14.654 2.6596 15.0362 2.8427L15.0418 2.84549C15.5157 3.07588 15.8034 3.55157 15.7744 4.0577L15.7737 4.06964C15.7508 4.49182 15.8683 4.90958 16.1077 5.25812C16.397 5.68014 16.3969 6.2365 16.1074 6.65835C15.8682 7.00706 15.7508 7.42498 15.7737 7.84716L15.7744 7.85845C15.8034 8.36458 15.5157 8.84043 15.0416 9.07099L15.0367 9.07328C14.6537 9.25688 14.34 9.55895 14.1421 9.93499L14.1397 9.93989C13.8991 10.3977 13.3964 10.6754 12.8609 10.6468L12.8492 10.6461C12.4213 10.6223 11.9965 10.7327 11.6344 10.962C11.1776 11.2477 10.5976 11.2477 10.1408 10.962C9.81152 10.7533 9.4296 10.6427 9.03982 10.643C9.00202 10.643 8.96406 10.644 8.92609 10.6461L8.91431 10.6466C8.38659 10.6802 7.88734 10.404 7.63517 9.93908L7.63174 9.93269C7.43439 9.55797 7.12152 9.25688 6.73943 9.07377L6.73322 9.07066C6.25916 8.84027 5.97149 8.36441 6.00062 7.85845L6.00127 7.84651C6.02402 7.42433 5.90653 7.0064 5.66729 6.65802C5.37815 6.23601 5.37831 5.67965 5.66779 5.25796V5.25763Z"
          fill="#2F3F5E"
        />
        <path
          d="M12.5512 7.05174C12.5512 7.31841 12.4846 7.56908 12.3512 7.80374C12.2232 8.03841 12.0312 8.23574 11.7752 8.39574C11.5246 8.55574 11.2259 8.65174 10.8792 8.68374V9.33174H10.3592V8.68374C9.85789 8.63574 9.45255 8.47841 9.14322 8.21174C8.83389 7.94508 8.67922 7.59308 8.67922 7.15574H9.65522C9.67122 7.36374 9.73789 7.53708 9.85522 7.67574C9.97255 7.80908 10.1406 7.89441 10.3592 7.93174V6.17174C10.0019 6.08108 9.71122 5.99041 9.48722 5.89974C9.26322 5.80374 9.07122 5.65441 8.91122 5.45174C8.75655 5.24908 8.67922 4.97174 8.67922 4.61974C8.67922 4.17708 8.83389 3.81174 9.14322 3.52374C9.45255 3.23041 9.85789 3.05974 10.3592 3.01174V2.36374H10.8792V3.01174C11.3486 3.05441 11.7246 3.20374 12.0072 3.45974C12.2952 3.71041 12.4579 4.05708 12.4952 4.49974H11.5192C11.5032 4.33441 11.4392 4.18774 11.3272 4.05974C11.2152 3.92641 11.0659 3.83574 10.8792 3.78774V5.51574C11.2366 5.60108 11.5272 5.69174 11.7512 5.78774C11.9752 5.87841 12.1646 6.02508 12.3192 6.22774C12.4739 6.42508 12.5512 6.69974 12.5512 7.05174ZM9.60722 4.57174C9.60722 4.79041 9.67122 4.96108 9.79922 5.08374C9.93255 5.20641 10.1192 5.30508 10.3592 5.37974V3.76374C10.1299 3.79041 9.94589 3.87308 9.80722 4.01174C9.67389 4.15041 9.60722 4.33708 9.60722 4.57174ZM10.8792 7.93174C11.1139 7.89441 11.2979 7.80108 11.4312 7.65174C11.5646 7.49708 11.6312 7.31308 11.6312 7.09974C11.6312 6.88641 11.5646 6.72108 11.4312 6.60374C11.3032 6.48108 11.1192 6.38241 10.8792 6.30774V7.93174Z"
          fill="#2F3F5E"
        />
        <path
          d="M17.9565 13.1953C17.5127 12.4077 16.5286 12.1078 15.7211 12.5139L13.0959 13.7543C12.7334 13.0803 12.0381 12.6512 11.273 12.6296L8.84953 12.5629C8.4658 12.5519 8.08928 12.4545 7.7481 12.2785L7.5015 12.1507C6.23889 11.4925 4.73394 11.4942 3.47263 12.1549L3.48802 11.5963C3.49309 11.4112 3.34729 11.2571 3.16222 11.252L0.50478 11.1788C0.319708 11.1738 0.165727 11.3196 0.160655 11.5046L0.000128454 17.3364C-0.00494426 17.5215 0.140855 17.6757 0.325926 17.6807L2.98336 17.7539H2.99269C3.17416 17.7537 3.32258 17.6092 3.32765 17.4279L3.33518 17.1489L4.02556 16.7793C4.29654 16.6335 4.6135 16.5988 4.90952 16.6825L9.03198 17.8396C9.03918 17.8417 9.04638 17.8434 9.05374 17.845C9.35172 17.9074 9.65543 17.9386 9.95996 17.9385C10.6047 17.9388 11.2419 17.7999 11.8279 17.5308C11.8423 17.5243 11.8562 17.5168 11.8694 17.5083L17.8467 13.6417C17.9958 13.5455 18.0439 13.3496 17.9565 13.1953ZM0.679379 17.0198L0.821414 11.8583L2.80893 11.9129L2.66673 17.0746L0.679379 17.0198ZM11.5258 16.9319C10.7978 17.2605 9.98467 17.3512 9.20216 17.1911L5.09066 16.0373C4.62806 15.9064 4.13258 15.9608 3.70925 16.1884L3.35645 16.3772L3.45103 12.9453C4.56883 12.2017 6.0026 12.1253 7.19321 12.7456L7.43981 12.8734C7.87082 13.096 8.34635 13.2189 8.8312 13.2328L11.2546 13.2996C11.9354 13.319 12.5135 13.8037 12.6516 14.4707L9.0418 14.3714C8.85673 14.3663 8.70275 14.5121 8.69767 14.6972C8.6926 14.8822 8.8384 15.0364 9.02347 15.0415L13.0072 15.1511H13.0167C13.198 15.1509 13.3464 15.0064 13.3515 14.8251C13.3556 14.6795 13.3446 14.5337 13.3191 14.3903L16.0112 13.1181L16.019 13.1143C16.401 12.9209 16.8629 12.9855 17.1769 13.2763L11.5258 16.9319Z"
          fill="#2F3F5E"
        />
      </svg>
    );
  };
  const Invite = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M4.42857 0V5.86207M13.5714 0V5.86207M3.85714 8.7931H7.28571M14.1429 8.7931H10.7143M3.85714 12.3103H7.28571M10.7143 12.3103H14.1429M2.14286 2.93103H15.8571C16.4883 2.93103 17 3.45595 17 4.10345V15.8276C17 16.4751 16.4883 17 15.8571 17H2.14286C1.51168 17 1 16.4751 1 15.8276V4.10345C1 3.45595 1.51167 2.93103 2.14286 2.93103Z"
          stroke="#9401B9"
        />
      </svg>
    );
  };
  const DiscusAgent = () => {
    return (
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9182 1.71376C11.0141 1.41437 10.0298 1.25 9 1.25C4.58172 1.25 1 4.27594 1 8.00862C1 9.46604 1.54603 10.8157 2.4747 11.9196L1.5 16.5L5.41607 14.0527C6.49418 14.5099 7.71152 14.7672 9 14.7672C13.4183 14.7672 17 11.7413 17 8.00862C17 7.32386 16.8795 6.66288 16.6553 6.04001"
          stroke="#9401B9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 1V5"
          stroke="#9401B9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 3H13"
          stroke="#9401B9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const ViewAllOff = () => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_25447_51386)">
          <path
            d="M9.16602 5H16.666"
            stroke="#2F3F5E"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.16602 10H16.666"
            stroke="#2F3F5E"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 15H16.6667"
            stroke="#2F3F5E"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.33398 13.3327C3.33398 12.8907 3.50958 12.4667 3.82214 12.1542C4.1347 11.8416 4.55862 11.666 5.00065 11.666C5.44268 11.666 5.8666 11.8416 6.17916 12.1542C6.49172 12.4667 6.66732 12.8907 6.66732 13.3327C6.66732 13.8252 6.25065 14.166 5.83398 14.5827L3.33398 16.666H6.66732"
            stroke="#2F3F5E"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.00065 8.33398V3.33398L3.33398 5.00065"
            stroke="#2F3F5E"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_25447_51386">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const WithdrawLastAct = () => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.34314 3.58142C6.46733 0.457234 11.5326 0.457234 14.6569 3.58142C17.781 6.70561 17.781 11.7709 14.6569 14.8952C11.5326 18.0193 6.46733 18.0193 3.34314 14.8952C0.218952 11.7709 0.218952 6.70561 3.34314 3.58142Z"
          stroke="#2F3F5E"
          stroke-linecap="round"
        />
        <path
          d="M3.66602 3.9043L14.3327 14.5709"
          stroke="#2F3F5E"
          stroke-linecap="round"
        />
      </svg>
    );
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClicke = (event) => {
    if (matchessm) {
      setActionDrawerOpen(true);
    } else {
      setAnchorEl(event.currentTarget);
      setOpen(true);
    }
  };

  const handleClosee = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const discussAgent = (data) => {
    const input = {
      offerUniqueId: data,
    };

    discussWithAgent(input).then((res) => {
      handleClosee();
      if (res?.status == 1) {
        onShowChat(res?.binderId);
      }
    });
  };

  const [openn, setOpen] = React.useState(false);
  const id = openn ? 'simple-popover' : undefined;

  useEffect(() => {
    if (name?.length > 0) {
      handleMobileNumberOnLoad();
      setSelectedVendorName(name[0]?.user?.userName);
    }
  }, [name]);

  const handleMobileNumberOnLoad = (e) => {
    let mobileNumberOnLoad = '';

    let newArray = name?.filter((el) => {
      return el?.isPrimary === 1;
    });

    if (newArray?.length > 0) {
      mobileNumberOnLoad = newArray[0]?.user.userId;

      setSelectedOption(mobileNumberOnLoad);
    } else if (name?.length > 0) {
      mobileNumberOnLoad = name[0]?.user.userId;

      setSelectedOption(mobileNumberOnLoad);
    }
  };

  const handleMobileNumber = (e) => {
    setSelectedOption(e);

    let newArray = name?.filter((el) => {
      return el?.user?.userId === e;
    });
    let mobileNumber = '';
    if (newArray?.length > 0) {
      mobileNumber = newArray[0]?.userMobile;
    }
  };

  const handleCall = (email, mobileNumber) => {
    // if (primaryUserTypeValue != 'Vendor') {
    //   localStorage.setItem('dialId', email);
    //   setShowMessage(true);
    //   setMessagedata({ incomingcall: true });
    // }
    return window.open(`tel:` + mobileNumber);
  };

  const lastupdated = moment(data?.lastUpdated).format('DD-MM-YYYY');
  const [mount, setMount] = useState(true);
  const [activitydata, setActivitydata] = useState([]);
  const [properties, setProperties] = useState([]);

  const Warning = () => {
    return (
      <svg
        width="38"
        height="36"
        viewBox="0 0 38 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="37.5797"
          height="36"
          rx="18"
          fill="#10D35E"
          fill-opacity="0.1"
        />
        <path
          d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
          fill="#10D35E"
        />
      </svg>
    );
  };

  const Invertedmenu = () => {
    return (
      <svg
        width="21"
        height="5"
        viewBox="0 0 21 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1816 2.49996C12.1816 3.4303 11.4274 4.18449 10.497 4.18449C9.56669 4.18449 8.8125 3.4303 8.8125 2.49996C8.8125 1.56962 9.56669 0.81543 10.497 0.81543C11.4274 0.81543 12.1816 1.56962 12.1816 2.49996Z"
          fill="#666666"
        />
        <path
          d="M3.75968 2.49996C3.75968 3.4303 3.00549 4.18449 2.07515 4.18449C1.14481 4.18449 0.390625 3.4303 0.390625 2.49996C0.390625 1.56962 1.14481 0.81543 2.07515 0.81543C3.00549 0.81543 3.75968 1.56962 3.75968 2.49996Z"
          fill="#666666"
        />
        <path
          d="M20.6034 2.49996C20.6034 3.4303 19.8492 4.18449 18.9189 4.18449C17.9886 4.18449 17.2344 3.4303 17.2344 2.49996C17.2344 1.56962 17.9886 0.81543 18.9189 0.81543C19.8492 0.81543 20.6034 1.56962 20.6034 2.49996Z"
          fill="#666666"
        />
      </svg>
    );
  };
  const [messageToBuyer, setMessageToBuyer] = useState('');
  const [forwardOfferCheckList, setForwardOfferCheckList] = useState([]);
  const [selectedUserNames, setSelectedUserNames] = useState([]);
  const [selectedUserSurNames, setSelectedUserSurNames] = useState([]);

  const replyToVendorFunc = (vendorofferUniqueId, vendorofferStatus) => {
    let input = {
      offerUniqueId: vendorofferUniqueId,
      offerStatus: vendorofferStatus,
    };

    replyToVendorStatus(input).then((res) => {
      if (res?.status == '1') {
        const binderId = res.binderId;
        directcommuni(binderId);
      } else {
        Swal.fire({
          title: res?.heading ? res?.heading : 'Error',
          text: res?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      }
    });
  };

  const directcommuni = (binderId) => {
    onShowChat(binderId);
  };

  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));

  const dataa = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(dataa);
  const userType = userDetail?.primaryUserType;

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    if (primaryUserTypeValue != 'Vendor') {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${props?.profileDetails?.PropertyDetails?.property?.propertyId}` +
          `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.dataForOtherBuyersAck))
      Moxoseparationinlisting(
        'dataForBuyerAckNotST2',
        res?.dataForOtherBuyersAck
      ); //1
    if (isNotEmptyArray(res?.dataForBuyerAck))
      Moxoseparationinlisting('dataForBuyerAckST2', res?.dataForBuyerAck); //2
    if (isNotEmptyArray(res?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.dataForVendorAck); //3
  };

  const forwardOfferToBuyerFunction = () => {
    setLoader(true);
    let newArr = [];
    for (let index = 0; index < forwardOfferCheckList.length; index++) {
      const element = forwardOfferCheckList[index];
      if (element != '') {
        let obj = { offerUniqueId: element };
        newArr.push(obj);
      }
    }
    var txt = data?.price;
    var vendorOffer = txt.match(/\d/g);
    vendorOffer = vendorOffer.join('');
    let input = {
      propertyId: params?.dashboardId,
      campaignId: props?.profileDetails?.PropertyDetails?.campaignId,
      offerUniqueId: newArr,
      timerStage: 'ST2',
      timerStatus: 'Start',
      vendorOfferPrice: vendorOffer,
    };

    stageTwoSwitching(input)
      .then((res) => {
        if (res?.status == '1') {
          setLoader(false);
          setForwardtobuyerbox(!forwardtobuyerbox);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
              getListInfo();
              activityfun();
              offerdata();
              moxoapis(res);
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setLoader(false);
          setForwardtobuyerbox(!forwardtobuyerbox);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => setLoader(false));
  };

  const handleStage2CancelClick = () => {
    setForwardOfferCheckList([]);
    setForwardtobuyerbox(!forwardtobuyerbox);
  };

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setDialogOpen(true);
    setOpen(false);
  };

  const handleMouseLeave = () => {
    setTimeout(() => {
      setIsHovered(false);
    }, 1500);
  };

  const userDetails = JSON.parse(localStorage.getItem('userDetail'));

  const nameDetails =
    props?.profileDetails?.PropertyDetails?.propertyOwnerDetails
      ?.filter((item) => item?.user?.userId != userDetails?.userId)
      ?.sort((a, b) => {
        if (a?.isPrimary === 1 && b?.isPrimary !== 1) return -1;
        if (a?.isPrimary !== 1 && b?.isPrimary === 1) return 1;
        return 0;
      }) || [];

  const isScreenlessthan600 = useMediaQuery('(max-width:600px)');
  const isScreenlessthan450 = useMediaQuery('(max-width:450px)');
  const [tabAlign, setTabAlign] = useState(false);

  const [file, setFile] = useState(null);
  const [pdfEmbedUrl, setPdfEmbedUrl] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);

  useEffect(() => {
    const fileFromAPI =
      props?.profileDetails?.PropertyDetails?.vendorStatus
        ?.offerAcceptanceCertificate;

    setFile(fileFromAPI);

    if (fileFromAPI && acceptanceCertificate) {
      setPdfLoading(true);
      const embedUrl = `${fileFromAPI}#toolbar=0`;
      setPdfEmbedUrl(embedUrl);

      // Set a timeout to handle loading errors
      const timeoutId = setTimeout(() => {
        setPdfLoading(false);
      }, 2000);

      return () => clearTimeout(timeoutId);
    } else {
      setPdfEmbedUrl(null);
      setPdfLoading(false);
    }
  }, [
    props?.profileDetails?.PropertyDetails?.vendorStatus
      ?.offerAcceptanceCertificate,
    acceptanceCertificate,
  ]);
  const [managePrivateOffer, setManagePrivateOffer] = useState(false);

  // define getcall ONCE, at the top level of your component
  const [submitLoading, setSubmitLoading] = useState(false);
  const [buyerHistory, setBuyerHistory] = useState([]);
  const [vendorHistoryData, setVendorHistoryData] = useState([]);
  const [privateoffer, setPrivateOffer] = useState([]);
  const [refreshBuyerHistory, setRefreshBuyerHistory] = useState(0);

  // ✅ Clean API call, only sets state on success
  // ✅ Define outside
  const getcall = async () => {
    setSubmitLoading(true);
    try {
      const propertyId =
        props?.profileDetails?.PropertyDetails?.property?.propertyId;

      if (propertyId) {
        return null;
      }

      const response = await getApiCall(AGENT_MANAGE_PRIVATE_OFFER, {
        propertyId,
      });

      if (response?.data?.status == 1) {
        setVendorHistoryData(response.data.vendorHistory || []);
        setPrivateOffer(response.data.recentPrivateOffer || {});
        setBuyerHistory(response.data.buyerHistory || []);
      } else {
        console.warn('Fetch failed:', response?.data?.message);
      }
    } catch (error) {
      console.error('API Error:', error);
    } finally {
      setSubmitLoading(false);
    }
  };

  // ✅ Click handler that triggers getcall
  const handleOpen = () => {
    getcall(); // Call API on click
    setManagePrivateOffer(true);
    setOpen(false);
  };

  // ✅ Example to refresh manually from anywhere:
  const refreshData = () => {
    setRefreshBuyerHistory((prev) => prev + 1);
  };

  const handleClose = () => setManagePrivateOffer(false);

  const [openFinalContractDialog, setOpenFinalContractDialog] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [openPrepareDialog, setOpenPrepareDialog] = useState(false);
  const [uploadedPdf, setUploadedPdf] = useState(null);
  const [uploadedContractUrl, setUploadedContractUrl] = useState(null);
  const primaryOwner =
    props?.profileDetails?.PropertyDetails?.propertyOwnerDetails?.find(
      (owner) => owner?.isPrimary === 1
    );
  const ownerFullName = `${primaryOwner?.user?.userName || ''} ${
    primaryOwner?.user?.userSurName || ''
  }`;

  const handleOpenFinalContractDialog = () => {
    setOpenFinalContractDialog(true);
  };

  const handleCloseFinalContractDialog = () => {
    setOpenFinalContractDialog(false);
  };

  const handleFinalContractSubmit = async (file, buyerIdFromSelection) => {
    setUploadedPdf(file);
    setSignBuyerId(buyerIdFromSelection || 0);
    setOpenUploadDialog(false);
    setOpenPrepareDialog(true);
    try {
      const formData = new FormData();
      formData.append('propertyId', params?.dashboardId);
      formData.append(
        'vendorId',
        props?.profileDetails?.PropertyDetails?.propertyOwnerDetails?.[0]?.user
          ?.userId
      );
      formData.append('buyerId', 0);
      formData.append('contractFile', file);
      const response = await postApiCall(CONTRACT_FILE_UPLOAD, formData);

      if (response?.data?.status === 1) {
        setUploadedContractUrl(response.data.contractFile);
      }
    } catch (error) {}
  };

  const handleClosePrepareDialog = () => {
    setOpenPrepareDialog(false);
  };

  const handleCloseAllContractDialogs = () => {
    setOpenPrepareDialog(false);
    setOpenFinalContractDialog(false);
  };

  const [openESign, setOpenESign] = useState(false);
  const [pdfMeta, setPdfMeta] = useState(null);
  const handleCommenceESign = async () => {
    try {
      const response = await getApiCall(VENDOR_REQUEST_SIGN_TEMPLATE, {
        propertyId: params?.dashboardId,
      });

      if (response?.data?.status === 1) {
        const { contractFile, fields } = response.data;

        setPdfMeta({
          contractFile,
          fields,
        });

        setOpenESign(true);
      }
    } catch (error) {
      console.error('Failed to fetch sign template', error);
    }
  };

  const [openViewDialog, setOpenViewDialog] = useState(false);

  const [hasVendorContract, setHasVendorContract] = React.useState(false);
  const [isEsignRequested, setIsEsignRequested] = React.useState(false);

  useEffect(() => {
    setHasVendorContract(
      !!props?.profileDetails?.PropertyDetails?.vendorContractFile
    );
    setIsEsignRequested(
      props?.profileDetails?.PropertyDetails?.isEsignRequested === 'Requested'
    );
  }, [
    props?.profileDetails?.PropertyDetails?.vendorContractFile,
    props?.profileDetails?.PropertyDetails?.isEsignRequested,
  ]);

  const handleOpenView = () => {
    setOpenViewDialog(true);
  };

  const handleCloseView = () => {
    setOpenViewDialog(false);
  };

  return (
    <>
      {' '}
      <Card sx={{ ...vendorCard, borderRadius: matchessm ? '10px' : '5px' }}>
        <Grid
          sx={[
            vendorTop,
            { justifyContent: menuicon ? 'right' : 'space-between' },
          ]}
        >
          {!menuicon && (!isScreenlessthan600 || !tabAlign) && (
            <Grid item xs={4}>
              {!Glass && (
                <CardHeaderContainer
                  title="Vendor Status"
                  icon={vendorStatus}
                  sx={{ backgroundColor: '#000000' }}
                />
              )}
              {Glass && (
                <CardHeaderContainer
                  title={
                    isScreenlessthan450
                      ? 'Offer Status'
                      : 'Current Offer Status'
                  }
                  icon={vendorStatus}
                  sx={{ backgroundColor: '#000000' }}
                />
              )}
            </Grid>
          )}
          {!isScreenlessthan600 &&
            primaryUserTypeValue != 'Vendor' &&
            props?.profileDetails?.PropertyDetails?.propertyOwnerDetails
              ?.length > 0 && (
              <Grid
                item
                sx={{
                  ...vendorRight,
                }}
              >
                {!matchessm && (
                  <Grid
                    container
                    sx={{ display: 'flex', flexDirection: 'row', gap: '8px' }}
                  >
                    <Grid item sx={vendorAvatar}>
                      {nameDetails[selectedVendorIndex]?.user?.userProfile ==
                        '' ||
                      nameDetails[selectedVendorIndex]?.user?.userProfile ==
                        null ? (
                        <Avatar
                          style={{
                            height: '26px',
                            width: '26px',
                            fontFamily: 'poppins',
                            fontSize: '12px',
                            backgroundColor: '#666666',
                          }}
                        >
                          {nameDetails[selectedVendorIndex]?.user?.userName
                            .charAt(0)
                            ?.toUpperCase() +
                            nameDetails[selectedVendorIndex]?.user?.userSurName
                              .charAt(0)
                              ?.toUpperCase()}
                        </Avatar>
                      ) : (
                        <Avatar
                          alt={nameDetails[selectedVendorIndex]?.user?.userName}
                          src={
                            nameDetails[selectedVendorIndex]?.user?.userProfile
                          }
                          style={{ height: '26px', width: '26px' }}
                        />
                      )}
                      {props?.profileDetails?.PropertyDetails
                        ?.propertyOwnerDetails?.length > 1 ? (
                        <Select
                          sx={{
                            ...poppins400,
                            ...fontsize16,
                            color: '#112347 !important',
                            boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                            '.MuiOutlinedInput-notchedOutline': {
                              border: 'none',
                            },
                            '.MuiSelect-select': {
                              paddingLeft: '4px',
                            },
                            outline: 'none',
                          }}
                          size="small"
                          value={selectedOptionCos}
                          style={{
                            padding: '0px 2px',
                            boxShadow: 'none',
                            color: '#112347',
                          }}
                          onChange={(e) => {
                            setSelectedOptionCos(e.target.value);
                            handleMobileNumber(e.target.value);
                            setDrawerOpen((prev) => !prev);
                            setSelectedVendorIndex(e.target.value - 1);
                          }}
                        >
                          {nameDetails?.map((item, index) => (
                            <MenuItem value={index + 1} key={index}>
                              {item?.user?.userName} {item?.user?.userSurName}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        <Typography
                          sx={{ fontFamily: 'poppins', margin: '0 5px' }}
                        >{`${nameDetails[0]?.user?.userName} ${nameDetails[0]?.user?.userSurName}`}</Typography>
                      )}
                    </Grid>
                    <Grid item>
                      <Avatar
                        variant="rounded"
                        style={{
                          border: '1px solid rgba(0, 0, 0, 0.12)',
                          background: 'white',
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          directcomm(
                            nameDetails[selectedOptionCos - 1]?.user?.userId
                          )
                        }
                      >
                        <Message height={16} width={16} />
                      </Avatar>
                    </Grid>
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                      }}
                    >
                      <Grid>
                        <Avatar
                          variant="rounded"
                          style={{
                            border: '1px solid rgba(0, 0, 0, 0.12)',
                            background: 'white',
                            cursor: 'pointer',
                          }}
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={handleMouseLeave}
                          onClick={() =>
                            handleCall(
                              nameDetails[selectedOptionCos - 1]?.userEmail,
                              nameDetails[selectedOptionCos - 1]?.userMobile
                            )
                          }
                        >
                          <Call height={16} width={16} />
                        </Avatar>
                      </Grid>

                      {/* <Grid
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginRight: '30px',
                          cursor: 'pointer',
                        }}
                        onClick={handleClick}
                      >
                        {isHovered && <Calldownarrow />}
                      </Grid>
                      {name?.map((item, index) => (
                        <MenuItem value={item?.user?.userId} key={index}>
                          {item && (
                            <ContactPopOver
                              name={
                                nameDetails[selectedOptionCos - 1]?.user
                                  ?.userName
                              }
                              surname={
                                nameDetails[selectedOptionCos - 1]?.user
                                  ?.userSurName
                              }
                              emailid={
                                nameDetails[selectedOptionCos - 1]?.userEmail
                              }
                              mobilenum={
                                nameDetails[selectedOptionCos - 1]?.userMobile
                              }
                              isDialogOpen={isDialogOpen}
                              setDialogOpen={setDialogOpen}
                              anchorEl={anchorEl}
                              setAnchorEl={setAnchorEl}
                            />
                          )}
                        </MenuItem>
                      ))} */}
                    </Grid>
                  </Grid>
                )}
                {menuicon && (
                  <>
                    <Grid sx={vendorAvatar}>
                      <Avatar
                        alt="Remy Sharp"
                        src={UserImg}
                        style={{ height: '26px', width: '25px' }}
                      />

                      <Select
                        sx={{
                          ...poppins400,
                          ...fontsize16,
                          color: '#112347 !important',
                          boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                          '.MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                          },
                          outline: 'none',
                        }}
                        size="small"
                        defaultValue={selectedOption}
                        value={selectedOption}
                        style={{
                          padding: '0px 2px',
                          boxShadow: 'none',
                          color: '#112347',
                        }}
                        onChange={(e) => {
                          handleMobileNumber(e.target.value);
                        }}
                      >
                        {name?.map((item, index) => (
                          <MenuItem value={item?.user?.userId} key={index}>
                            {item?.user?.userName}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Avatar
                      variant="rounded"
                      style={{
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        background: 'white',
                      }}
                    >
                      <Message height={16} width={16} />
                    </Avatar>

                    <Avatar
                      variant="rounded"
                      style={{
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        background: 'white',
                        cursor: 'pointer',
                      }}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={handleMouseLeave}
                      onClick={() =>
                        handleCall(
                          nameDetails[selectedOptionCos - 1]?.userEmail,
                          nameDetails[selectedOptionCos - 1]?.userMobile
                        )
                      }
                    >
                      <Call height={16} width={16} />
                    </Avatar>
                    {/* <Grid
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginRight: '30px',
                        cursor: 'pointer',
                      }}
                      onClick={handleClick}
                    >
                      {isHovered && <Calldownarrow />}
                    </Grid>
                    {name?.map((item, index) => (
                      <MenuItem value={item?.user?.userId} key={index}>
                        {item && (
                          <ContactPopOver
                            name={
                              nameDetails[selectedOptionCos - 1]?.user?.userName
                            }
                            surname={
                              nameDetails[selectedOptionCos - 1]?.user
                                ?.userSurName
                            }
                            emailid={
                              nameDetails[selectedOptionCos - 1]?.userEmail
                            }
                            mobilenum={
                              nameDetails[selectedOptionCos - 1]?.userMobile
                            }
                            isDialogOpen={isDialogOpen}
                            setDialogOpen={setDialogOpen}
                            anchorEl={anchorEl}
                            setAnchorEl={setAnchorEl}
                          />
                        )}
                      </MenuItem>
                    ))} */}
                  </>
                )}
                {matchessm && !menuicon && (
                  <Typography
                    sx={{
                      border: '1px solid #F0F0F0',
                      borderRadius: '50%',
                      padding: '7px 5px',
                      height: '41px',
                      display: 'flex',
                      alignItems: 'center',
                      width: '41px',
                      justifyContent: 'center',
                    }}
                  >
                    <Propertymenu
                      onClick={() => {
                        setMenuicon(!menuicon);
                      }}
                    />
                  </Typography>
                )}
                {menuicon && (
                  <Typography
                    sx={{
                      border: '1px solid #F0F0F0',
                      borderRadius: '50%',
                      padding: '7px 5px',
                      height: '41px',
                      display: 'flex',
                      alignItems: 'center',
                      marginLeft: '10px',
                      width: '41px',
                      justifyContent: 'center',
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        setMenuicon(!menuicon);
                      }}
                    >
                      <Invertedmenu />
                    </IconButton>
                  </Typography>
                )}
              </Grid>
            )}

          {isScreenlessthan600 &&
            primaryUserTypeValue != 'Vendor' &&
            props?.profileDetails?.PropertyDetails?.propertyOwnerDetails
              ?.length > 0 && (
              <Grid
                item
                display={'flex'}
                marginTop={'-5px'}
                flexDirection={'column'}
                sx={{
                  ml: 'auto',
                  mr: primaryUserTypeValue == 'Vendor' ? '-210px' : '-80px',
                }}
              >
                <Grid
                  container
                  item
                  sx={{
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  <Grid item sx={{ ...vendorRight, alignItems: 'center' }}>
                    <Grid
                      item
                      sx={{
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        padding: '0px',
                        borderRadius: '5px',
                      }}
                    >
                      <FormControl sx={{ minWidth: 120, margin: '0px' }}>
                        <Select
                          sx={{
                            ...poppins400,
                            fontSize: matchessm ? '12px' : '16px',
                            color: '#112347 !important',
                            boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                            padding: 0,
                            margin: 0,
                            '.MuiOutlinedInput-root': {
                              padding: '0px',
                              margin: '0px',
                            },
                            '.MuiSelect-icon': {
                              border: '0px',
                              borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
                              top: '0',
                              right: '0',
                              margin: '0px',
                              height: '100%',
                              display: 'flex',
                              alignItems: 'center', // Center aligns the icon vertically.
                              justifyContent: 'center',
                            },

                            '.MuiSelect-iconOpen': {
                              border: '0px',
                              borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                            },
                            '.MuiInputBase-input': {
                              padding: '0px',
                              margin: '5px 0px',
                            },
                            '.MuiOutlinedInput-notchedOutline': {
                              border: 'none',
                            },
                            '.MuiSelect-root': {
                              margin: '0px',
                            },
                            outline: 'none',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                          size="small"
                          value={selectedOption}
                          style={{
                            boxShadow: 'none',
                            color: '#112347',
                          }}
                          onChange={(e) => {
                            handleMobileNumber(e.target.value);
                            const selectedName = name.find(
                              (item) => item.user.userId == e.target.value
                            );
                            setSelectedVendorName(
                              selectedName?.user?.userName || ''
                            );
                          }}
                          startAdornment={
                            <InputAdornment
                              position="start"
                              sx={{ marginLeft: '5px' }}
                            >
                              <Avatar
                                alt="Remy Sharp"
                                src={UserImg}
                                sx={{
                                  height: '24px',
                                  width: '24px',
                                  marginRight: '8px',
                                }}
                              />
                            </InputAdornment>
                          }
                          inputProps={{ 'aria-label': 'Without label' }}
                        >
                          {name?.map((item, index) => (
                            <MenuItem
                              value={item?.user?.userId}
                              onClick={(e) => {
                                setDrawerOpen(!openDrawer);
                                setSelectedVendor(item);
                              }}
                            >
                              {item?.user?.userName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginRight: '30px',
                        cursor: 'pointer',
                      }}
                      onClick={handleClick}
                    >
                      {isHovered && <Calldownarrow />}
                    </Grid>
                    {name?.map((item, index) => (
                      <MenuItem value={item?.user?.userId} key={index}>
                        {item && (
                          <ContactPopOver
                            name={
                              nameDetails[selectedOptionCos - 1]?.user?.userName
                            }
                            surname={
                              nameDetails[selectedOptionCos - 1]?.user
                                ?.userSurName
                            }
                            emailid={
                              nameDetails[selectedOptionCos - 1]?.userEmail
                            }
                            mobilenum={
                              nameDetails[selectedOptionCos - 1]?.userMobile
                            }
                            isDialogOpen={isDialogOpen}
                            setDialogOpen={setDialogOpen}
                            anchorEl={anchorEl}
                            setAnchorEl={setAnchorEl}
                          />
                        )}
                      </MenuItem>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            )}
        </Grid>
        <Grid
          container
          sx={{ ...displayFlex, ...counterOffer, border: '1px solid #F0F0F0' }}
        >
          {data && data?.price != null && (
            <Grid
              item
              lg={3}
              xl={3}
              md={6}
              sm={12}
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: matcheslg ? 'center' : 'left',
              }}
            >
              {data ? (
                data?.status != null ? (
                  <Grid
                    container
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Grid item>
                      <div>
                        <BadgeButton
                          offerStatus={data?.status}
                          isnew={data?.isNew}
                          Vendorpadding={true}
                        />
                      </div>
                    </Grid>
                    {data?.statusBuyer === 'Buyer Notified' && (
                      <Grid item>
                        <Typography
                          sx={[
                            {
                              borderRadius: '17px',

                              width: '135px',
                              padding: '1px 10px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '5px',
                              border: '1px solid rgba(11, 168, 218, 1)',
                            },
                          ]}
                        >
                          <Typography>
                            <Alert color="rgba(11, 168, 218, 1)" />
                          </Typography>
                          <Typography
                            whiteSpace={'nowrap'}
                            sx={{
                              ...poppins300,
                              fontSize: '12px',
                              color: 'rgba(11, 168, 218, 1)',
                            }}
                          >
                            {'Buyer Notified'}
                          </Typography>
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  ''
                )
              ) : (
                Glass &&
                (statusVendor == null ? (
                  ''
                ) : (
                  <Typography
                    sx={[
                      counterOfferButton,
                      {
                        border: '1px solid ',
                        borderColor: !statusVendor
                          ? 'orange'
                          : statusVendor === 'Accepted'
                          ? 'rgba(16, 211, 94, 1)'
                          : statusVendor === 'Rejected'
                          ? 'rgba(249, 57, 57, 1)'
                          : 'rgba(243, 152, 0, 1)',
                      },
                    ]}
                  >
                    <Typography>
                      <Alert
                        color={
                          !statusVendor
                            ? 'orange'
                            : statusVendor === 'Accepted'
                            ? 'rgba(16, 211, 94, 1)'
                            : statusVendor === 'Rejected'
                            ? 'rgba(249, 57, 57, 1)'
                            : 'rgba(243, 152, 0, 1)'
                        }
                      />
                    </Typography>
                    <Typography
                      whiteSpace={'nowrap'}
                      sx={{
                        ...poppins300,
                        fontSize: '14px',
                        color: !statusVendor
                          ? 'orange'
                          : statusVendor === 'Accepted'
                          ? 'rgba(16, 211, 94, 1)'
                          : statusVendor === 'Rejected'
                          ? 'rgba(249, 57, 57, 1)'
                          : 'rgba(243, 152, 0, 1)',
                      }}
                    >
                      {statusVendor
                        ? statusVendor === 'Counter Offer'
                          ? 'Counter Offer Submitted'
                          : statusVendor
                        : 'Pending'}
                    </Typography>
                  </Typography>
                ))
              )}
            </Grid>
          )}

          <Grid
            item
            lg={data?.price === null ? 10 : 5}
            xl={data?.price === null ? 10 : 5}
            md={data?.price === null ? 12 : 5}
            sm={12}
            xs={12}
            gap={!matcheslg && 3}
            sx={{
              display: 'flex',
              flexDirection: matcheslg ? 'column' : 'row',
              alignItems: 'center',
              justifyContent:
                data?.statusBuyer === 'Buyer Notified' ? 'center' : 'center',
              position: 'relative',
            }}
            marginTop={
              (matcheslg && data?.price === null) ||
              (matchesmd && data?.price != null)
                ? '20px'
                : '0px'
            }
          >
            {data ? (
              data?.price === null ? (
                <Box
                  sx={{
                    left: { lg: '10%' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%', // Ensure it takes the full height of the container
                    width: '100%', // Ensure it takes the full width of the container
                    position: 'absolute',
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'poppins',
                      fontWeight: 500,
                      color: '#585858',
                      fontSize: '14px',
                    }}
                  >
                    No vendor status found
                  </Typography>
                </Box>
              ) : (
                <Typography
                  sx={{ ...poppins600, ...fontsize32, color: '#112347' }}
                >
                  {' '}
                  {data?.price}
                </Typography>
              )
            ) : null}

            {vendorPrice ? (
              vendorPrice?.price === null ? (
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontWeight: '20px',
                    color: '#585858',
                    fontSize: '14px',
                  }}
                >
                  No vendor status found
                </Typography>
              ) : (
                <Typography
                  sx={{ ...poppins600, ...fontsize32, color: '#112347' }}
                >
                  {' '}
                  {vendorPrice?.price}
                </Typography>
              )
            ) : null}

            {data ? (
              <>
                <Box sx={{ ...poppins400, fontSize: '12px' }}>
                  <Typography
                    sx={{ ...poppins400, fontSize: '12px' }}
                    style={{ color: '#112347' }}
                  >
                    {data?.lastUpdated == null ? '' : 'Last Updated:'}
                  </Typography>
                  <Typography sx={{ ...poppins400, fontSize: '12px' }}>
                    &nbsp;
                    {data?.lastUpdated == null
                      ? ''
                      : dateformatBasedOnUserType(
                          data?.lastUpdated,
                          userDetail?.primaryUserType
                        )}
                  </Typography>
                </Box>
              </>
            ) : null}

            {vendorPrice ? (
              <>
                <Box sx={{ ...poppins400, fontSize: '12px' }}>
                  <Typography
                    sx={{ ...poppins400, fontSize: '12px' }}
                    style={{ color: '#112347' }}
                  >
                    {vendorPrice?.lastUpdated == null ? '' : 'Last Updated:'}
                  </Typography>
                  <Typography sx={{ ...poppins400, fontSize: '12px' }}>
                    &nbsp;
                    {vendorPrice?.lastUpdated == null
                      ? ''
                      : vendorPrice?.lastUpdated}
                  </Typography>
                </Box>
              </>
            ) : null}
          </Grid>
          {data?.lastUpdated === null || vendorPrice?.lastUpdated == null ? (
            ''
          ) : (
            <Grid
              item
              lg={2}
              xl={2}
              md={6}
              sm={6}
              xs={12}
              sx={{ display: 'flex', justifyContent: 'center' }}
              marginTop={matcheslg && '20px'}
            >
              <Typography
                sx={{ ...displayFlexColumn }}
                style={{ alignItems: 'center' }}
              >
                <Typography
                  whiteSpace={'nowrap'}
                  sx={{
                    ...poppins400,
                    fontSize: '14px',
                    color: 'rgba(17, 35, 71, 0.5)',
                  }}
                  style={{ color: 'rgba(17, 35, 71, 0.5)' }}
                >
                  Initial True Estimate
                </Typography>
                <Typography
                  sx={{ ...poppins500, fontSize: '12px', color: ' #112347' }}
                  style={{ color: 'black', textAlign: 'center' }}
                >
                  $ {datamain?.propertytrueEstimate}
                </Typography>
              </Typography>
            </Grid>
          )}
          <Grid
            item
            lg={2}
            xl={2}
            md={12}
            sm={12}
            xs={12}
            textAlign={matcheslg ? 'center' : 'right'}
            marginTop={matcheslg && '20px'}
          >
            <Typography
              sx={{
                background: ' #FFFFFF',

                borderRadius: '5px',
              }}
            >
              <Grid sx={{ marginRight: !matcheslg && '40px' }}>
                <Typography aria-describedby={id} onClick={handleClicke}>
                  <Button
                    onClick={handleClicke}
                    sx={[
                      menuitemfont,
                      {
                        ...poppins500,
                        ...fontsize14,
                        boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                        '.MuiOutlinedInput-notchedOutline': { border: 0 },
                        outline: 'none',
                        color: 'black',
                        borderRadius: '5px',
                        textTransform: 'none',
                      },
                    ]}
                  >
                    Action &nbsp; &nbsp; <ActionDown />
                  </Button>
                </Typography>
                {userType != 'Vendor' ? (
                  <Popover
                    id={id}
                    open={openn}
                    anchorEl={anchorEl}
                    onClose={handleClosee}
                    PaperProps={{
                      style: {
                        boxShadow: 'none',
                        border: '1px solid #D9D9D9',
                        borderRadius: '4px',
                      },
                    }}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <MenuItem
                      value={20}
                      sx={{
                        minHeight: matchessm ? '0px' : '',
                        cursor: 'default',
                      }}
                      disableRipple
                      disableTouchRipple
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 400,
                          fontSize: '12px',
                          color: '#8E8A8A',
                          lineHeight: 'normal',
                          fontStyle: 'normal',
                        }}
                      >
                        - Action for {ownerFullName} -
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      value={20}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      disabled
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <Invite /> Meeting Invite
                      </Typography>
                    </MenuItem>
                    <Divider />

                    <MenuItem
                      value={20}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      disabled={
                        !data?.price ||
                        data?.status == 'Private Offer' ||
                        data?.buyerId == 0
                      }
                      onClick={() => {
                        handleClosee();
                        vendorStatusManageOfferClick();
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <Offer /> Manage Offer
                      </Typography>
                    </MenuItem>

                    <MenuItem
                      value={20}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      disabled={!data?.price}
                      onClick={() => {
                        handleClosee();
                        replyToVendorFunc(
                          vendorofferUniqueId,
                          vendorofferStatus
                        );
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <Reply /> Reply to Vendor
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      value={20}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      disabled={
                        !data?.price ||
                        vendorofferStatus != 'Counter Offer' ||
                        (vendorofferStatus == 'Counter Offer' &&
                          data?.statusBuyer == 'Buyer Notified') ||
                        stage == 'ST2'
                      }
                      onClick={() => {
                        handleClosee();
                        setForwardCountertobuyer(true);
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <ForwardOff /> Forward Counter Offer
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      value={20}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      disabled={
                        !data?.price ||
                        (vendorofferStatus == 'Rejected' &&
                          data?.statusBuyer != 'Buyer Notified') ||
                        !(
                          vendorofferStatus == 'Counter Offer' ||
                          vendorofferStatus == 'Accepted'
                        )
                      }
                      onClick={() => {
                        handleClosee();
                        setAcceptanceCertificate(true);
                        setOpen(false);
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <Filemanagericon width={18} height={19} /> Acceptance
                        Certificates
                      </Typography>
                    </MenuItem>

                    <MenuItem
                      value={20}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      disabled={
                        profileDetails?.PropertyDetails?.property?.status ==
                        'Unpublish'
                      }
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                        onClick={() => {
                          handleClosee();
                          handleOpen();
                        }}
                      >
                        <Offer />
                        Manage Private Offer
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      value={20}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      onClick={() => {
                        handleClosee();
                        handleOpendeposit();
                      }}
                      disabled={
                        profileDetails?.PropertyDetails?.property?.status ==
                        'Unpublish'
                      }
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <RequestIcon /> Deposit Manager
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      value={20}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      disabled={
                        profileDetails?.PropertyDetails?.property?.status ==
                        'Unpublish'
                      }
                      onClick={() => {
                        handleClosee();
                        hasVendorContract
                          ? handleOpenView()
                          : handleOpenFinalContractDialog();
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2px',
                          marginLeft: '-4px',
                        }}
                      >
                        <SignContract />{' '}
                        {hasVendorContract
                          ? 'View Signed Contract'
                          : 'Initiate Sign Request'}
                      </Typography>
                    </MenuItem>

                    <Divider />
                    <MenuItem
                      value={20}
                      disabled={
                        props?.profileDetails?.PropertyDetails?.stage ==
                          'ST2' ||
                        !stagetwo ||
                        isWinner == 1
                      }
                      onClick={() => {
                        handleClosee();
                        setOpenCommenceStageTwo(true);
                        setOpen(false);
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <Timer /> Start Stage Timer 2
                      </Typography>
                      <Divider />
                    </MenuItem>
                    <MenuItem
                      value={20}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      onClick={() => {
                        handleClosee();
                        history.push('/helpcentre');
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <NeedHelp /> Need Help
                      </Typography>
                    </MenuItem>
                  </Popover>
                ) : (
                  <Popover
                    id={id}
                    open={openn}
                    anchorEl={anchorEl}
                    onClose={handleClosee}
                    PaperProps={{
                      style: {
                        boxShadow: 'none',
                        border: '1px solid #D9D9D9',
                        borderRadius: '4px',
                        minWidth: '274px',
                      },
                    }}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <MenuItem value={20}>
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 400,
                          fontSize: '12px',
                          color: '#8E8A8A',
                          lineHeight: 'normal',
                          fontStyle: 'normal',
                        }}
                      >
                        - Offer Status Action -
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      value={20}
                      disabled={data?.offerUniqueId == undefined ? true : false}
                      onClick={() => {
                        handleClosee();
                        discussAgent(data?.offerUniqueId);
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <DiscusAgent /> Discuss with Agent
                      </Typography>
                    </MenuItem>
                    <Divider />
                    <MenuItem
                      value={20}
                      onClick={() => {
                        handleClosee();
                        manageOfferClick();
                      }}
                      disabled={
                        !data?.price ||
                        data?.status == 'Private Offer' ||
                        data?.buyerId == 0
                      }
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <Offer /> Manage Offer
                      </Typography>
                    </MenuItem>
                    {(manageOffer || openhistorydialog) && (
                      <ManageOffer
                        open={manageOffer}
                        vendorDatas={vendorDatas}
                        onClose={manageOfferClickClose}
                        buyerId={data?.buyerId}
                        offerUniqueIds={data?.offerUniqueId}
                        getListInfo={getListInfo}
                        row={data}
                        tableData={props?.profileDetails}
                        moxouserId={true}
                        setManageOffer={setManageOffer}
                        setOpenhistorydialog={setOpenhistorydialog}
                        acceptLog={acceptLog}
                        Glass={Glass}
                        setVendorGeneratePdf={setVendorGeneratePdf}
                      />
                    )}
                    <MenuItem value={20} disabled={true}>
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <ViewAllOff /> View All Offers
                      </Typography>
                    </MenuItem>

                    <Divider />
                    <MenuItem
                      value={20}
                      disabled={
                        profileDetails?.PropertyDetails?.privateOfferDetails ==
                          null ||
                        profileDetails?.PropertyDetails?.timerStatus == 'End' ||
                        profileDetails?.PropertyDetails?.timerStatus == 'Pause'
                      }
                      onClick={() => {
                        handleClosee();
                        setViewPrivateOffer(true);
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <PrivateOffer /> View Private Offer
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      value={20}
                      disabled={!isEsignRequested && !hasVendorContract}
                      sx={{ minHeight: matchessm ? '0px' : '' }}
                      onClick={() => {
                        handleClosee();
                        isEsignRequested
                          ? handleCommenceESign()
                          : handleOpenView();
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <SignContract />
                        {isEsignRequested
                          ? 'Commence E-Sign'
                          : 'View Signed Contract'}
                      </Typography>
                    </MenuItem>

                    <Divider />
                    <MenuItem
                      value={20}
                      onClick={() => {
                        handleClosee();
                        history.push('/helpcentre');
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins!important',
                          fontWeight: 300,
                          fontSize: '14px',
                          color: '#2F3F5E',
                          fontStyle: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <NeedHelp /> Need Help
                      </Typography>
                    </MenuItem>
                  </Popover>
                )}
              </Grid>
            </Typography>
          </Grid>
        </Grid>
        {(vendorStatusManageOffer || openhistorydialog) && (
          <ManageOffer
            open={vendorStatusManageOffer}
            onClose={vendorStatusManageClickClose}
            offerStatusdata={offerStatusdata}
            buyerId={data?.buyerId}
            offerUniqueIds={data?.offerUniqueId}
            getListInfo={getListInfo}
            row={data}
            vendorDatas={vendorDatas}
            moxouserId={true}
            setManageOffer={setManageOffer}
            setOpenhistorydialog={setOpenhistorydialog}
            tableData={buyerRegisterTableData}
            setVendorGeneratePdf={setVendorGeneratePdf}
          />
        )}
        {openDepositManager && (
          <DepositManagerPopup
            openDepositManager={openDepositManager}
            handleClosedeposit={handleClosedeposit}
            setOpen={setOpen}
            profileDetails={profileDetails}
            getListInfo={getListInfo}
            manageOfferClick={manageOfferClick}
            fromVendorStatus={true}
          />
        )}
        <VendorActionDrawer
          setViewPrivateOffer={setViewPrivateOffer}
          acceptLog={acceptLog}
          Glass={Glass}
          discussAgent={discussAgent}
          userType={userType}
          setOpenCommenceStageTwo={setOpenCommenceStageTwo}
          isWinner={isWinner}
          stagetwo={stagetwo}
          setOpen={setOpen}
          profileDetails={profileDetails}
          open={actionDrawerOpen}
          setActionDrawerOpen={setActionDrawerOpen}
          data={data}
          manageOfferClick={manageOfferClick}
          getListInfo={getListInfo}
          vendorDatas={vendorDatas}
          setManageOffer={setManageOffer}
          setOpenhistorydialog={setOpenhistorydialog}
          buyerRegisterTableData={buyerRegisterTableData}
          manageOffer={manageOffer}
          manageOfferClickClose={manageOfferClickClose}
          openhistorydialog={openhistorydialog}
          offerStatusdata={offerStatusdata}
          handleClosee={handleClosee}
          vendorofferStatus={vendorofferStatus}
          vendorofferUniqueId={vendorofferUniqueId}
          replyToVendorFunc={replyToVendorFunc}
          setForwardCountertobuyer={setForwardCountertobuyer}
          setAcceptanceCertificate={setAcceptanceCertificate}
          handleOpen={handleOpen}
          stage={stage}
          handleCommenceESign={handleCommenceESign}
          handleOpenFinalContractDialog={handleOpenFinalContractDialog}
          setVendorGeneratePdf={setVendorGeneratePdf}
          handleOpenView={handleOpenView}
          hasVendorContract={hasVendorContract}
          isEsignRequested={isEsignRequested}
          ownerFullName={ownerFullName}
        />
        <Dialog
          open={openWithdrawVendor}
          PaperProps={{
            sx: {
              borderRadius: '5px',
              minWidth: matchessm ? '95%' : '400px',
              boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
              padding: '20px',
            },
          }}
        >
          <Grid container height={'100%'}>
            <Grid item xs={12}>
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: matchessm ? '10px' : '14px',
                  color: '#666666',
                }}
              >
                {'   '}
                {
                  props?.profileDetails?.PropertyDetails?.propertyAddress
                    ?.streetName
                }
                &nbsp;
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              display={'flex'}
              alignItems={'center'}
              padding={'12px 0px 15px 0'}
            >
              <Pendingwarning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '16px' : '24px',
                  paddingLeft: '12px',
                }}
              >
                Withdraw Last Action
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                Do you want to withdraw the last action ?
              </Typography>
            </Grid>

            <Grid
              item
              container
              direction="row"
              justifyContent={'flex-end'}
              gap={2}
              marginTop={matchessm ? '15px' : 5}
            >
              <Grid item>
                <Button
                  variant="outlined"
                  style={{
                    padding: matchessm ? '6px 23px' : '10px 39px',
                    width: '100%',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '14px',
                    color: '#666666',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    borderRadius: '5px',
                    textTransform: 'capitalize',
                  }}
                  onClick={() => setOpenWithdrawVendor(false)}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid
                item
                sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <Button
                  variant="outlined"
                  style={{
                    padding: matchessm ? '6px 23px' : '10px 39px',
                    width: '100%',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '14px',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    background: '#4CA4D6',
                    borderRadius: '5px',
                    textTransform: 'capitalize',
                  }}
                  disabled={openWithdrawVendorLoader}
                  onClick={() =>
                    withDrawFunc(
                      data?.offerStatusId,
                      data?.offerUniqueId,
                      data?.status
                    )
                  }
                >
                  Confirm
                </Button>
                {openWithdrawVendorLoader && (
                  <CircularProgress
                    size={27}
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      color: '#4CA4D6',
                      marginTop: 0,
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Dialog>

        {forwardcountertobuyer && (
          <ForwardCounterOfferPopup
            open={forwardcountertobuyer}
            onClose={() => {
              setForwardCountertobuyer(false);
              getListInfo();
            }}
            VendorForward={true}
            vendorCounterPrice={vendorCounterPrice}
            formattedVendorCounterPrice={formattedVendorCounterPrice}
            setShareMarketPlace={setShareMarketPlace}
            getListInfo={getListInfo}
            address={address}
            offerUniqueId={vendorofferUniqueId}
            selectedrowbuyername={selectedrowbuyername}
            buyerOfferPrice={buyerOfferPrice}
            sharedToMarket={sharedToMarket}
            {...props}
          />
        )}

        {shareMarketPlace && (
          <ShareOfferWithMarketPlace
            shareMarketPlace={shareMarketPlace}
            setShareMarketPlace={setShareMarketPlace}
            getListInfo={getListInfo}
            address={address}
            offerUniqueId={vendorofferUniqueId}
            selectedrowbuyername={selectedrowbuyername}
            buyerOfferPrice={buyerOfferPrice}
          />
        )}

        <Dialog
          open={forwardtovendor}
          onClose={() => setForwardtovendor(!forwardtovendor)}
          PaperProps={{
            sx: {
              borderRadius: '5px',
              minWidth: matchessm ? '100%' : '650px',
              boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
              padding: '30px',
            },
          }}
        >
          <Grid container height={'100%'}>
            <Grid item xs={12}>
              <Typography
                sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
              >
                {' '}
                {
                  props?.profileDetails?.PropertyDetails?.propertyAddress
                    ?.propertyNo
                }{' '}
                {
                  props?.profileDetails?.PropertyDetails?.propertyAddress
                    ?.streetName
                }{' '}
                {
                  props?.profileDetails?.PropertyDetails?.propertyAddress
                    ?.landmark
                }{' '}
                {props?.profileDetails?.PropertyDetails?.propertyAddress?.state}{' '}
                {props?.profileDetails?.PropertyDetails?.propertyAddress?.city}{' '}
                &nbsp;
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              display={'flex'}
              alignItems={'center'}
              padding={'10px 0px'}
            >
              <Warning />
              <Typography
                sx={{ ...poppins500, fontSize: '24px', paddingLeft: '12px' }}
              >
                Forward Offer to vendor
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography
                sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
              >
                Forward your Buyer's current offer to vendor
              </Typography>
            </Grid>

            <Grid
              item
              xs={matchessm ? 6 : 4.5}
              textAlign={'left'}
              paddingTop={'30px'}
            >
              <Typography
                sx={{ ...poppins500, fontSize: '18px' }}
                whiteSpace={'nowrap'}
              >
                Buyer Offer :{' '}
              </Typography>
            </Grid>
            <Grid
              item
              xs={matchessm ? 6 : 7.5}
              paddingLeft={'20px'}
              paddingTop={'30px'}
            >
              <Typography sx={{ ...poppins400, fontSize: '18px' }}>
                $250000
              </Typography>
            </Grid>

            <Grid
              item
              xs={matchessm ? 12 : 4.5}
              justifyContent={'left'}
              paddingTop={'30px'}
              display={'flex'}
              alignItems={'start'}
            >
              <Typography
                sx={{ ...poppins500, fontSize: '18px', textAlign: 'right' }}
                whiteSpace={'nowrap'}
              >
                Message to vendor :{' '}
              </Typography>
            </Grid>

            <Grid
              item
              xs={matchessm ? 12 : 7.5}
              paddingLeft={matchessm ? null : '20px'}
              paddingTop={'25px'}
              display={'flex'}
              alignItems={'center'}
            >
              <Typography
                width={'100%'}
                sx={{
                  display: 'flex',
                  alignItems: 'left',
                  justifyContent: 'left',
                }}
              >
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  variant="standard"
                  sx={{
                    color: '#000000',
                    borderRadius: '5px',
                    padding: '5px',
                    border: '1px solid #F0F0F0',
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                  placeholder="Text message"
                  type="text"
                  name="name"
                  inputProps={{ style: { fontFamily: 'poppins' } }}
                  InputProps={{ disableUnderline: 'true' }}
                />
              </Typography>
            </Grid>
            <Grid
              item
              container
              direction="row"
              justifyContent={matchessm ? 'center' : 'flex-end'}
              gap={2}
              marginTop={2}
            >
              <Grid item>
                <Button
                  variant="outlined"
                  style={{
                    padding: '10px 39px',
                    width: '100%',
                    height: '41px',
                    fontSize: '14px',
                    color: '#666666',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    borderRadius: '5px',
                  }}
                  onClick={() => setForwardtovendor(!forwardtovendor)}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  type="submit"
                  style={{
                    padding: '10px 39px',
                    width: '100%',
                    height: '41px',
                    fontSize: '14px',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    background: '#4CA4D6',
                    borderRadius: '5px',
                  }}
                >
                  &nbsp;Send&nbsp;
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Dialog>

        <Dialog
          open={acceptanceCertificate}
          onClose={() => setAcceptanceCertificate(!acceptanceCertificate)}
          PaperProps={{
            sx: {
              borderRadius: '5px',
              minWidth: matchessm ? '100%' : '650px',
              boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
              padding: '30px',
              overflow: 'hidden',
            },
          }}
        >
          <Grid container height={'100%'}>
            <Grid item xs={12}>
              <Typography
                sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
              >
                {' '}
                {
                  props?.profileDetails?.PropertyDetails?.propertyAddress
                    ?.streetName
                }{' '}
                &nbsp;
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              display={'flex'}
              alignItems={'center'}
              padding={'10px 0px'}
            >
              <Warning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '20px' : '24px',
                  paddingLeft: '12px',
                }}
              >
                Acceptance Certificate
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <div style={{ width: '100%', height: '780px' }}>
                {pdfLoading ? (
                  <Box
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      alt="Loading"
                      src={Loading}
                      className="loaderImage"
                      style={{ height: '75px', width: '75px' }}
                    />
                  </Box>
                ) : pdfEmbedUrl ? (
                  <CommonPdfViewer
                    fileUrl={pdfEmbedUrl}
                    onDocumentLoad={() => {
                      setPdfLoading(false);
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Typography sx={{ ...poppins400, color: '#666666' }}>
                      No PDF file available
                    </Typography>
                  </Box>
                )}
              </div>
            </Grid>

            <Grid
              item
              container
              direction="row"
              justifyContent={matchessm ? 'center' : 'flex-end'}
              gap={2}
              marginTop={2}
            >
              <Grid item>
                <Button
                  variant="outlined"
                  style={{
                    padding: '10px 39px',
                    width: '100%',
                    height: '41px',
                    fontSize: '14px',
                    color: '#666666',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    borderRadius: '5px',
                    textTransform: 'none',
                  }}
                  onClick={() => {
                    setAcceptanceCertificate(!acceptanceCertificate);
                  }}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
        {openCommenceStageTwo && (
          <CommenceStageTwo
            openCommenceStageTwo={openCommenceStageTwo}
            onCloseCommenceStageTwo={() => setOpenCommenceStageTwo(false)}
            stageData={props?.profileDetails}
            getListInfo={getListInfo}
            offerdata={offerdata}
            activityfun={activityfun}
            stage2AcceptanceCertificate={stage2AcceptanceCertificate}
            setStage2AcceptanceCertificate={setStage2AcceptanceCertificate}
          />
        )}

        {openstagetwoCommence && (
          <Stage2Commence
            setOpenBox={setstagetwoCommence}
            getListInfo={getListInfo}
            openBox={openstagetwoCommence}
            setOpenCommenceStageTwo={setOpenCommenceStageTwo}
            stageData={props?.profileDetails}
            profileDetails={profileDetails}
            userDetail={userDetail}
            setStage2AcceptanceCertificate={setStage2AcceptanceCertificate}
            activityfun={activityfun}
            offerdata={offerdata}
            stage2AcceptanceCertificate={stage2AcceptanceCertificate}
          />
        )}

        <PrivateOfferConfirmationPopup
          open={viewPrivateOffer}
          onClose={() => {
            setViewPrivateOffer(false);
            setOpen(false);
            history.push({
              pathname: history.location.pathname,
              state: { privateofferprice: null },
            });
          }}
          profileDetails={profileDetails}
          privateOfferDetails={
            profileDetails?.PropertyDetails?.privateOfferDetails
          }
          propertyAddress={
            profileDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          getListInfo={getListInfo}
        />

        {matchessm && (
          <ContactDrawer
            open={openDrawer}
            setDrawerOpen={setDrawerOpen}
            name={selectedVendorName}
            handleCall={handleCall}
            selectedVendor={selectedVendor}
            setSelectedVendor={setSelectedVendor}
            directcomm={directcomm}
          />
        )}
      </Card>
      {managePrivateOffer && (
        <ManagePrivateOffer
          vendorHistoryData={vendorHistoryData}
          setVendorHistoryData={setVendorHistoryData}
          privateoffer={privateoffer}
          setPrivateOffer={setPrivateOffer}
          buyerHistory={buyerHistory}
          setBuyerHistory={setBuyerHistory}
          handleOpen={handleOpen}
          open={managePrivateOffer}
          setManagePrivateOffer={setManagePrivateOffer}
          handleClose={handleClose}
          handleClosee={handleClosee}
          tableData={props?.profileDetails}
          getListInfo={getListInfo}
          profileDetails={profileDetails}
          vendorDatas={vendorDatas}
          directcomm={directcomm}
        />
      )}
      {viewPrivateOfferlinkpopup && (
        <Privateofferdetailslink
          open={viewPrivateOfferlinkpopup}
          address={
            props?.profileDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          setViewPrivateOffer={setViewPrivateOffer}
          setViewPrivateOfferlinkpopup={setViewPrivateOfferlinkpopup}
        />
      )}
      {openFinalContractDialog && (
        <FinalContractUploadDialog
          open={openFinalContractDialog}
          onClose={handleCloseFinalContractDialog}
          onSubmit={handleFinalContractSubmit}
          streetName={
            props?.profileDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          matchessm={matchessm}
          userType={userType}
          isVendorContainer={true}
          getListInfo={getListInfo}
        />
      )}
      {openPrepareDialog && (
        <PrepareContractSignDialog
          open={openPrepareDialog}
          onCancel={handleClosePrepareDialog}
          onSuccess={handleCloseAllContractDialogs}
          pdfFile={uploadedPdf}
          streetName={
            props?.profileDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          matchessm={matchessm}
          contractFileUrl={uploadedContractUrl}
          propertyId={params.dashboardId}
          buyerId={props?.buyerId}
          vendorId={primaryOwner?.user?.userId}
          VendorContainer={true}
          userName={ownerFullName}
          signBuyerId={signBuyerId}
          propertyOwnerDetails={
            props?.profileDetails?.PropertyDetails?.propertyOwnerDetails
          }
        />
      )}
      {openESign && (
        <CommenceESignDialog
          open={openESign}
          onClose={() => setOpenESign(false)}
          pdfMeta={pdfMeta}
          streetName={address}
          matchessm={matchessm}
          userDetail={userDetail}
          propertyId={
            props?.profileDetails?.PropertyDetails?.property?.propertyId
          }
          getListInfo={getListInfo}
        />
      )}
      {openViewDialog && (
        <ViewCommenceEsignPdf
          open={openViewDialog}
          onClose={handleCloseView}
          taskPath={props?.profileDetails?.PropertyDetails?.vendorContractFile}
          streetName={
            props?.profileDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          matchessm={matchessm}
          statusLastUpdatedAt={
            props?.profileDetails?.PropertyDetails?.vendorContractSignedAt
          }
          onInitiateEsign={handleOpenFinalContractDialog}
          primaryUserTypeValue={primaryUserTypeValue}
          isArchived={props?.profileDetails?.PropertyDetails?.isArchived === 1}
        />
      )}
    </>
  );
}
export default VendorStatusContainer;
